const escapeText = (v) => String(v).replace(/\\/g, "\\\\").replace(/\r?\n/g, "\\n").replace(/([,;])/g, "\\$1");

const fold = (line) => {
  const out = [];
  let rest = line;
  while (rest.length > 75) {
    out.push(rest.slice(0, 75));
    rest = ` ${rest.slice(75)}`;
  }
  out.push(rest);
  return out.join("\r\n");
};

export function buildVCard(id) {
  const name = id.fullName || "";
  const parts = name.split(/\s+/).filter(Boolean);
  const last = parts.length > 1 ? parts.pop() : "";
  const lines = ["BEGIN:VCARD", "VERSION:3.0", `N:${escapeText(last)};${escapeText(parts.join(" "))};;;`, `FN:${escapeText(name)}`];
  if (id.title) lines.push(`TITLE:${escapeText(id.title)}`);
  if (id.company) lines.push(`ORG:${escapeText(id.company)}`);
  if (id.phone) lines.push(`TEL;TYPE=CELL,VOICE:${escapeText(id.phone)}`);
  if (id.email) lines.push(`EMAIL;TYPE=INTERNET:${escapeText(id.email)}`);
  const url = id.publicProfileUrl || id.website;
  if (url) lines.push(`URL:${url}`);
  if (id.photoUrl) lines.push(`PHOTO;VALUE=URI:${id.photoUrl}`);
  lines.push("END:VCARD");
  return `${lines.map(fold).join("\r\n")}\r\n`;
}

export function downloadVCard(id) {
  const blob = new Blob([buildVCard(id)], { type: "text/vcard;charset=utf-8" });
  const href = URL.createObjectURL(blob);
  if (/iphone|ipad|ipod/i.test(navigator.userAgent) || !("download" in HTMLAnchorElement.prototype)) {
    window.location.href = href;
    setTimeout(() => URL.revokeObjectURL(href), 10000);
    return;
  }
  const a = document.createElement("a");
  a.href = href;
  a.download = `${(id.fullName || "contact").replace(/[^\w-]+/g, "-").replace(/^-+|-+$/g, "") || "contact"}.vcf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
